import * as React from 'react';
export const directdebitSvg = React.forwardRef(function directdebitSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'm9.45 13.666.003-7.335c-2.042.084-3.92 1.636-3.921 3.778-.001 2.165 2.203 3.422 3.918 3.557m5.276-5.861c.002-4.142-2.262-5.937-4.835-6.57v-.214C14.572 1.291 18 4.42 18 8.001c-.001 4.088-4.036 7.003-9.013 6.999C4.01 14.996-.001 11.856 0 7.987.001 3.927 3.507.995 9.48 1v5.043l-1.412-.031c-3.026.114-6.531 1.562-6.532 3.51 0 2.143 3.326 4.72 7.32 4.724 3.231.002 5.87-2.571 5.871-6.441',
      fillRule: 'evenodd',
    }),
  );
});
directdebitSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 18 16',
  width: '18',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var directdebit = {
  category: 'paymentmethod',
  colorable: true,
  name: 'directdebit',
  svg: directdebitSvg,
};
